export class SupportDashboardDetailRequestModel {
    public tenantId: string | null = null;
    public assetId: string | null = null;
    public assetName: string | null = null;
    public databaseType: string | null = null;
    public scale: string | null = null;
    public pageName: string | null = null;
    public chartName: string | null = null;
}